export default __webpack_public_path__ + "static/shop-image6-3ff93a5750245941f3cae890643de6c1.jpg";